import { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import axios from "axios";
import { eur } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ConsoleDocumenti } from "@/components/ConsoleDocumenti";
import { StatoLocali } from "@/components/StatoLocali";
import { FirmeLegali } from "@/components/FirmeLegali";
import { ConsoleAccessi } from "@/components/ConsoleAccessi";
import { RegalaMesi } from "@/components/RegalaMesi";
import { VetrinaAdmin } from "@/components/VetrinaAdmin";
import { RichiesteDemo } from "@/components/RichiesteDemo";
import { AvvioLocali } from "@/components/AvvioLocali";
import { AccessoLocale } from "@/components/AccessoLocale";
import { MenuLocale } from "@/components/MenuLocale";
import { SchedaCliente } from "@/components/SchedaCliente";
import { ProveDalVivo } from "@/components/ProveDalVivo";
import { BackupStato } from "@/components/BackupStato";
import { SaluteSistema } from "@/components/SaluteSistema";


import {
  Lock, ShieldCheck, Ban, Play, Ticket, Copy, Trash2, LogOut, Plus, Search, KeyRound, Building2, Users, Gift, Printer, AlertTriangle, Eye,
  CheckCircle2, Circle, UploadCloud, StickyNote, ClipboardCheck, ExternalLink, FileText, Rocket, FlaskConical, CalendarClock,
} from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KINDS = [
  { id: "free_months", label: "Mesi gratis" },
  { id: "percent", label: "Sconto %" },
  { id: "amount", label: "Sconto €" },
];
const LABELS = ["Presenta un professionista", "Compleanno", "Festività", "Fiera / evento", "Prova gratuita"];
const PLANS = ["free", "standard", "pro"];
const PLAN_NAME = { free: "Gratuito", standard: "Standard", pro: "Pro" };
const PLAN_PRICE = { free: 0, standard: 49, pro: 99 };
const dataIt = (s) => (s ? new Date(s).toLocaleDateString("it-IT") : "—");
// Quanto manca alla scadenza, in chiaro e con un colore che si capisce al volo
const GiorniBadge = ({ t }) => {
  if (t.days_left === null || t.days_left === undefined)
    return <span className="text-[11px] text-slate-500">senza scadenza</span>;
  const g = t.days_left;
  const stile = g < 0 ? "border-rose-500/30 bg-rose-500/15 text-rose-300"
    : g <= 7 ? "border-amber-500/30 bg-amber-500/15 text-amber-300"
    : "border-emerald-500/30 bg-emerald-500/15 text-emerald-300";
  return (
    <span className={`font-num rounded-full border px-2 py-0.5 text-[10px] font-bold ${stile}`} data-testid={`giorni-${t.slug}`}>
      {g < 0 ? `scaduto da ${Math.abs(g)} gg` : g === 0 ? "scade oggi" : `${g} gg`}
    </span>
  );
};

export default function Console() {
  const [token, setToken] = useState(() => localStorage.getItem("rh_admin") || "");
  const [pwdInput, setPwdInput] = useState("");
  const [otp, setOtp] = useState("");
  const [challenge, setChallenge] = useState(null);
  const [sentTo, setSentTo] = useState("");
  const [remember, setRemember] = useState(true);
  const [resetting, setResetting] = useState(false);   // recupero password in corso
  const [newPwd, setNewPwd] = useState("");
  const [showPwdBox, setShowPwdBox] = useState(false); // cambio password da dentro la console
  const [chgPwd, setChgPwd] = useState({ current_password: "", new_password: "" });
  const [clean, setClean] = useState(null);            // riepilogo della pulizia locali di prova
  const [cleanWord, setCleanWord] = useState("");
  const [cleanArch, setCleanArch] = useState(true);

  // Salvando la console sulla schermata Home, iOS deve riaprire /rh-console e non la pagina del gestionale
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return;
    const prima = link.getAttribute("href");
    link.setAttribute("href", "/manifest-console.json");
    document.title = "Console Reprehendo";
    return () => link.setAttribute("href", prima);
  }, []);
  const [audit, setAudit] = useState(null);
  const [data, setData] = useState(null);
  const [vouchers, setVouchers] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);
  const [tab, setTab] = useState("clienti");
  const [form, setForm] = useState({ name: "", vat: "", phone: "", contact: "", plan: "free", months: 12, allow_dup_vat: false });
  const [months, setMonths] = useState(12);
  const panelRef = useRef(null);
  const [gruppo, setGruppo] = useState("tutti");
  const [reason, setReason] = useState("Mancato pagamento");
  const [newCode, setNewCode] = useState(null);
  const [v, setV] = useState({ kind: "free_months", plan: "pro", months: 1, value: 50, label: LABELS[0], expires_days: 60, quantity: 1 });
  const [fb, setFb] = useState(null);
  const [funnel, setFunnel] = useState(null);
  const [trials, setTrials] = useState(null);
  const [scans, setScans] = useState(null);
  const [scheda, setScheda] = useState(null);
  const [note, setNote] = useState("");
  const [imp, setImp] = useState(null);
  const [impFile, setImpFile] = useState(null);
  const [impBusy, setImpBusy] = useState(false);
  const [avvisiSistema, setAvvisiSistema] = useState([]);
  const [quizGiorni, setQuizGiorni] = useState(30);
  const [clic, setClic] = useState(null);


  const client = axios.create({ baseURL: API, headers: { "X-Admin-Token": token } });

  const load = async () => {
    try {
      const [t, o, f, qf, cl, tr, au, sc] = await Promise.all([
        client.get("/admin/tenants"), client.get("/admin/overview"), client.get("/admin/feedback"),
        client.get(`/admin/quiz-funnel?days=${quizGiorni}`), client.get("/admin/clic"), client.get("/admin/trials"), client.get("/admin/audit?limit=60"),
        client.get("/admin/scans?days=30"),
      ]);
      setScans(sc.data);
      setData(t.data);
      setVouchers(o.data.vouchers);
      setFb(f.data);
      setFunnel(qf.data);
      setClic(cl.data);
      setTrials(tr.data);
      setAudit(au.data);
    } catch {
      localStorage.removeItem("rh_admin");
      setToken("");
    }
  };

  useEffect(() => {
    if (token) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  // Cambio periodo del test attività: ricarica solo quel riquadro
  useEffect(() => {
    if (!token) return;
    client.get(`/admin/quiz-funnel?days=${quizGiorni}`).then((r) => setFunnel(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quizGiorni]);

  // Avvisi di sistema: compaiono anche in «Da richiamare», si aggiornano da soli
  useEffect(() => {
    if (!token) return undefined;
    const tira = () => client.get("/admin/salute")
      .then((r) => setAvvisiSistema(r.data.avvisi || []))
      .catch(() => {});
    tira();
    const i = setInterval(tira, 120000);
    return () => clearInterval(i);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);


  // Scheda di lavoro del locale selezionato: checklist, note e import del listino
  useEffect(() => {
    setScheda(null);
    setImp(null);
    setImpFile(null);
    if (!sel || !token) return;
    axios
      .get(`${API}/admin/tenants/${sel}/scheda`, { headers: { "X-Admin-Token": token } })
      .then((r) => {
        setScheda(r.data);
        setNote(r.data.notes || "");
      })
      .catch(() => toast.error("Scheda del locale non disponibile"));
  }, [sel, token]);

  const act = async (fn, msg) => {
    try {
      const r = await fn();
      toast.success(msg);
      await load();
      return r?.data;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Operazione non riuscita");
    }
  };

  if (!token)
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4" data-testid="console-login">
        <Card className="w-full max-w-sm p-8">
          <ShieldCheck className="h-6 w-6 text-slate-400" />
          <h1 className="font-head mt-4 text-2xl font-bold">Console Reprehendo</h1>
          <p className="mt-1 text-sm text-slate-400">
            {challenge
              ? resetting
                ? `Ti ho mandato un codice a 6 cifre a ${sentTo}. Inseriscilo e scegli la nuova password.`
                : `Ti ho mandato un codice a 6 cifre a ${sentTo}. Vale 10 minuti.`
              : "Area riservata al fornitore. Serve la password e il codice che arriva per email."}
          </p>

          {!challenge ? (
            <>
              <Input
                className="mt-5 h-12"
                type="password"
                placeholder="Password della console"
                autoComplete="current-password"
                value={pwdInput}
                onChange={(e) => setPwdInput(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && document.querySelector('[data-testid="console-login-btn"]').click()}
                data-testid="console-password-input"
              />
              <Button
                className="mt-3 h-12 w-full"
                data-testid="console-login-btn"
                onClick={async () => {
                  try {
                    const r = await axios.post(`${API}/admin/login`, {
                      password: pwdInput,
                      device: localStorage.getItem("rh_admin_device") || "",
                    });
                    setPwdInput("");
                    if (r.data.token) {          // dispositivo già ricordato: dentro subito
                      localStorage.setItem("rh_admin", r.data.token);
                      setToken(r.data.token);
                      return;
                    }
                    setChallenge(r.data.challenge);
                    setSentTo(r.data.sent_to || "");
                    if (r.data.sent === false)
                      toast.error("Il servizio email è a limite: il codice arriverà tra poco, oppure riprova fra un minuto");
                    else toast.success("Codice inviato per email");
                  } catch (e) {
                    const st = e?.response?.status;
                    toast.error(
                      e?.response?.data?.detail ||
                        (!e?.response
                          ? "Server non raggiungibile: controlla la connessione e riprova"
                          : st === 429
                            ? "Troppi tentativi: attendi qualche minuto e riprova"
                            : st >= 500
                              ? `Errore del server (${st}): riprova tra poco`
                              : "Password non valida"),
                    );
                  }
                }}
              >
                <Lock className="mr-1.5 h-4 w-4" /> Continua
              </Button>
              <button
                className="mt-3 w-full text-xs font-semibold text-slate-400 hover:text-slate-600"
                data-testid="console-forgot-password-btn"
                onClick={async () => {
                  try {
                    const r = await axios.post(`${API}/admin/password/forgot`, {});
                    setResetting(true);
                    setChallenge(r.data.challenge);
                    setSentTo(r.data.sent_to || "");
                    setPwdInput("");
                    toast.success("Codice di recupero inviato per email");
                  } catch (e) {
                    toast.error(e?.response?.data?.detail || "Recupero non disponibile adesso");
                  }
                }}
              >
                Password dimenticata?
              </button>
            </>
          ) : resetting ? (
            <>
              <Input
                className="mt-5 h-12 text-center text-lg tracking-[0.4em]"
                placeholder="000000"
                inputMode="numeric"
                autoComplete="one-time-code"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                data-testid="console-reset-otp-input"
              />
              <Input
                className="mt-3 h-12"
                type="password"
                placeholder="Nuova password (almeno 12 caratteri)"
                autoComplete="new-password"
                value={newPwd}
                onChange={(e) => setNewPwd(e.target.value)}
                data-testid="console-reset-password-input"
              />
              <Button
                className="mt-3 h-12 w-full"
                data-testid="console-reset-btn"
                onClick={async () => {
                  try {
                    await axios.post(`${API}/admin/password/reset`, {
                      challenge,
                      code: otp,
                      new_password: newPwd,
                    });
                    toast.success("Password cambiata: entra con quella nuova");
                    setResetting(false);
                    setChallenge(null);
                    setOtp("");
                    setNewPwd("");
                  } catch (e) {
                    toast.error(e?.response?.data?.detail || "Cambio password non riuscito");
                  }
                }}
              >
                <KeyRound className="mr-1.5 h-4 w-4" /> Salva la nuova password
              </Button>
              <button
                className="mt-3 w-full text-xs font-semibold text-slate-400"
                data-testid="console-reset-back"
                onClick={() => {
                  setResetting(false);
                  setChallenge(null);
                  setOtp("");
                  setNewPwd("");
                }}
              >
                Annulla
              </button>
            </>
          ) : (
            <>
              <Input
                className="mt-5 h-12 text-center text-lg tracking-[0.4em]"
                placeholder="000000"
                inputMode="numeric"
                autoComplete="one-time-code"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                onKeyDown={(e) => e.key === "Enter" && document.querySelector('[data-testid="console-otp-btn"]').click()}
                data-testid="console-otp-input"
              />
              <label className="mt-3 flex items-center gap-2 text-xs font-semibold text-slate-600">
                <input
                  type="checkbox"
                  className="h-4 w-4 accent-slate-900"
                  checked={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                  data-testid="console-remember-device"
                />
                Ricorda questo dispositivo per 30 giorni
              </label>
              <Button
                className="mt-3 h-12 w-full"
                data-testid="console-otp-btn"
                onClick={async () => {
                  try {
                    const r = await axios.post(`${API}/admin/login/verify`, { challenge, code: otp, remember });
                    if (r.data.device) localStorage.setItem("rh_admin_device", r.data.device);
                    localStorage.setItem("rh_admin", r.data.token);
                    setToken(r.data.token);
                  } catch (e) {
                    toast.error(e?.response?.data?.detail || "Codice non valido");
                    setOtp("");
                  }
                }}
              >
                <ShieldCheck className="mr-1.5 h-4 w-4" /> Entra
              </Button>
              <button
                className="mt-3 w-full text-xs font-semibold text-slate-400"
                data-testid="console-otp-back"
                onClick={() => {
                  setChallenge(null);
                  setOtp("");
                }}
              >
                Ricomincia
              </button>
            </>
          )}
        </Card>
      </div>
    );

  if (!data) return <div className="p-8 text-sm text-slate-400">Caricamento console…</div>;

  const GRUPPI = [
    { id: "tutti", l: "Tutti" },
    { id: "pagante", l: "Paganti" },
    { id: "autorizzato", l: "Autorizzati da te" },
  ];
  // Clienti veri e demo/prove interne non si mescolano: due sezioni distinte della console.
  const sezione = tab === "demo"
    ? data.tenants.filter((t) => t.kind === "demo" || t.kind === "prova")
    : data.tenants.filter((t) => t.kind === "pagante" || t.kind === "autorizzato");
  const list = sezione.filter(
    (t) =>
      (tab === "demo" || gruppo === "tutti" || t.kind === gruppo) &&
      (!q || (t.name + t.vat + t.contact).toLowerCase().includes(q.toLowerCase())),
  );
  const apriGestione = (id) => {
    setSel(sel === id ? null : id);
    if (sel !== id) {
      // Su telefono il riquadro di gestione sta sotto l'elenco: lo portiamo sotto gli occhi
      setTimeout(() => panelRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 120);
    }
  };

  const TABS = [
    { id: "clienti", label: "Clienti", icon: Users },
    { id: "demo", label: "Demo", icon: FlaskConical },
    { id: "avvio", label: "Avvio", icon: Rocket },
    { id: "prove", label: "Prove", icon: Play },
    { id: "voucher", label: "Voucher", icon: Ticket },
    { id: "log", label: "Registro", icon: ShieldCheck },
    { id: "documenti", label: "Documenti", icon: FileText },
  ];
  // Cosa chiede attenzione adesso: si tocca e si va nella scheda giusta
  const righeProve = trials?.rows || [];
  const inScadenza = righeProve.filter((r) => r.state === "attiva" && (r.days_left ?? 99) <= 2);
  const ferme = righeProve.filter((r) => r.state === "attiva" && (r.progress?.done ?? 0) === 0);
  const sospesi = data.tenants.filter((t) => t.suspended);
  const senzaMenu = data.tenants.filter((t) => !t.suspended && (t.usage?.menu ?? 1) === 0);
  const votiBassi = (fb?.rows || []).filter((r) => Number(r.rating) <= 2);
  const daFare = [    ...inScadenza.map((r) => ({ id: `sc-${r.slug}`, tab: "prove", tid: r.id, tono: "amber",
      testo: `${r.name}: la prova scade fra ${r.days_left ?? 0} giorni`, azione: "Vai alla prova" })),
    ...ferme.map((r) => ({ id: `fe-${r.slug}`, tab: "prove", tid: r.id, tono: "amber",
      testo: `${r.name} non è ancora entrato nel gestionale`, azione: "Richiamalo" })),
    ...senzaMenu.map((t) => ({ id: `me-${t.slug}`, tab: "clienti", tid: t.id, tono: "sky",
      testo: `${t.name}: menu non ancora caricato`, azione: "Carica il listino" })),
    ...sospesi.map((t) => ({ id: `so-${t.slug}`, tab: "clienti", tid: t.id, tono: "rose",
      testo: `${t.name} è sospeso${t.suspend_reason ? ` · ${t.suspend_reason}` : ""}`, azione: "Apri la scheda" })),
    ...votiBassi.map((r) => ({ id: `vb-${r.id}`, tab: "log", tid: null, tono: "rose",
      testo: `Voto ${r.rating}/5 da ${r.business || r.tenant_name || "un locale"}: da richiamare`, azione: "Leggi il parere" })),
    ...avvisiSistema.map((a) => ({ id: `av-${a.chiave}`, tab: "log", tid: null, tono: "rose",
      testo: `${a.titolo}: ${a.dettaglio}`, azione: "Apri il registro" })),
  ];
  const TONI = {
    amber: "border-amber-500/25 bg-amber-500/10 text-amber-300",
    rose: "border-rose-500/25 bg-rose-500/10 text-rose-300",
    sky: "border-sky-500/25 bg-sky-500/10 text-sky-300",
  };
  const urgenze = [
    inScadenza.length && { id: "scadenza", tab: "prove", testo: `${inScadenza.length} prove scadono entro 2 giorni` },
    ferme.length && { id: "ferme", tab: "prove", testo: `${ferme.length} non sono ancora entrate nel gestionale` },
    sospesi.length && { id: "sospesi", tab: "clienti", testo: `${sospesi.length} attività sospese` },
  ].filter(Boolean);
  const current = list.find((t) => t.id === sel);
  // Chi scade prima sta in cima: così la situazione rinnovi si legge in un colpo d'occhio
  const scadenze = data.tenants
    .filter((t) => (t.kind === "pagante" || t.kind === "autorizzato") && t.current_period_end)
    .sort((a, b) => (a.days_left ?? 9999) - (b.days_left ?? 9999))
    .slice(0, 12);

  // I soldi: solo abbonamenti veri (Stripe). I piani concessi a mano non sono ricavi.
  const paganti = data.tenants.filter((t) => t.kind === "pagante" && !t.suspended);
  const mrr = paganti.reduce((s, t) => s + (PLAN_PRICE[t.plan] || 0), 0);
  const proveAttive = righeProve.filter((r) => r.state === "attiva");
  const potenziale = proveAttive.length * PLAN_PRICE.standard;
  const convertite = righeProve.filter((r) => r.state === "convertita").length;
  const soldi = [    { id: "mrr", l: "Abbonamenti al mese", v: eur(mrr), s: `${paganti.length} locali paganti${data.totals?.authorized ? ` · ${data.totals.authorized} autorizzati da te` : ""}` },
    { id: "anno", l: "Su base annua", v: eur(mrr * 12), s: "se nessuno disdice" },
    { id: "potenziale", l: "In gioco ora", v: eur(potenziale), s: `${proveAttive.length} prove attive` },
    {
      id: "conversione",
      l: "Prove convertite",
      v: righeProve.length ? `${Math.round((convertite / righeProve.length) * 100)}%` : "—",
      s: `${convertite} su ${righeProve.length} prove`,
    },
  ];

  return (
    <div className="min-h-screen overflow-x-hidden bg-[#090d16] px-4 py-6 text-slate-100 sm:px-8" data-testid="console-page">
      {/* campi di inserimento leggibili sul fondo scuro */}
      <style>{`[data-testid="console-page"] input { background:#0b1220; color:#e2e8f0; border-color:#1f2937 }
        [data-testid="console-page"] input::placeholder { color:#64748b }`}</style>
      <div className="mx-auto max-w-6xl space-y-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div>
            <p className="text-[10px] font-bold uppercase tracking-[0.28em] text-slate-400">Console fornitore</p>
            <h1 className="font-head mt-1 text-3xl font-bold">Reprehendo (RH)</h1>
          </div>
          <div className="flex w-full flex-wrap gap-2 sm:w-auto">
            <Button
              className="bg-amber-500 text-slate-950 hover:bg-amber-400"
              data-testid="console-kit-email-btn"
              onClick={() => act(() => client.post("/admin/kit/email", {}), "Materiale inviato per email")}
            >
              <Printer className="mr-1.5 h-4 w-4" /> Materiale
            </Button>
            <Button
              variant="outline"
              className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800"
              data-testid="console-cleanup-btn"
              onClick={async () => {
                if (clean) return setClean(null);
                try {
                  const r = await client.get("/admin/cleanup/preview");
                  setClean(r.data);
                  setCleanWord("");
                } catch (e) {
                  toast.error(e?.response?.data?.detail || "Riepilogo pulizia non disponibile");
                }
              }}
            >
              <Trash2 className="mr-1.5 h-4 w-4" /> Pulizia
            </Button>
            <Button
              variant="outline"
              className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800"
              data-testid="console-change-password-btn"
              onClick={() => setShowPwdBox((v) => !v)}
            >
              <Lock className="mr-1.5 h-4 w-4" /> Password
            </Button>
            <Button
              variant="outline"
              className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800"
              data-testid="console-forget-devices-btn"
              onClick={() => {
                if (!window.confirm("Dimentico tutti i dispositivi ricordati? Al prossimo accesso servirà di nuovo il codice via email.")) return;
                localStorage.removeItem("rh_admin_device");
                act(() => client.post("/admin/devices/forget"), "Dispositivi ricordati azzerati");
              }}
            >
              <KeyRound className="mr-1.5 h-4 w-4" /> Dispositivi
            </Button>
            <Button
              variant="outline"
              className="border-slate-700 bg-transparent text-slate-200 hover:bg-slate-800"
              data-testid="console-logout-btn"
              onClick={() => {
                localStorage.removeItem("rh_admin");
                setToken("");
              }}
            >
              <LogOut className="mr-1.5 h-4 w-4" /> Esci
            </Button>
          </div>
        </div>

        {clean && (
          <Card className="border-rose-900/60 bg-[#180f14] p-4 text-slate-100" data-testid="console-cleanup-box">
            <p className="text-sm font-semibold text-rose-300">Pulisci i locali di prova</p>
            <p className="mt-1 text-xs text-slate-400">
              Resta la vetrina d'esempio ({clean.keep.map((k) => k.slug).join(", ") || "nessuna"}) e
              ogni locale che dà segni di vita vera: registrato o entrato negli ultimi 7 giorni,
              con abbonamento o con comande già fatte. Quelli li vedi qui sotto come protetti.
            </p>
            <div className="mt-3 grid gap-2 text-xs sm:grid-cols-3">
              <div className="rounded-lg bg-slate-900 p-3">
                <p className="text-[10px] uppercase tracking-widest text-slate-500">Locali da eliminare</p>
                <p className="mt-1 text-2xl font-bold" data-testid="cleanup-count">{clean.remove.length}</p>
              </div>
              <div className="rounded-lg bg-slate-900 p-3">
                <p className="text-[10px] uppercase tracking-widest text-slate-500">Raccolte dati orfane</p>
                <p className="mt-1 text-2xl font-bold">{clean.orphan_collections}</p>
              </div>
              <div className="rounded-lg bg-slate-900 p-3">
                <p className="text-[10px] uppercase tracking-widest text-slate-500">Righe di archivio</p>
                <p className="mt-1 text-2xl font-bold">
                  {Object.entries(clean.archives)
                    .filter(([k]) => k !== "audit" && k !== "vouchers")
                    .reduce((s, [, v]) => s + v, 0)}                </p>
              </div>
            </div>
            <div className="mt-3 max-h-40 overflow-y-auto rounded-lg bg-slate-900/60 p-2 text-xs">
              {clean.remove.map((t) => (
                <div key={t.id} className="flex justify-between gap-2 border-b border-slate-800 py-1 last:border-0">
                  <span className="font-semibold">{t.name || t.slug}</span>
                  <span className="text-slate-500">
                    {t.slug} · {t.demo ? "demo" : t.trial ? "prova" : t.plan}
                  </span>
                </div>
              ))}
              {!clean.remove.length && <p className="text-slate-500">Niente da eliminare: è già pulito.</p>}
            </div>
            {clean.protected?.length > 0 && (
              <div className="mt-3 rounded-lg border border-emerald-900/60 bg-emerald-950/30 p-2 text-xs" data-testid="cleanup-protected">
                <p className="font-semibold text-emerald-300">
                  Protetti, non verranno toccati ({clean.protected.length})
                </p>
                {clean.protected.map((t) => (
                  <div key={t.id} className="flex flex-wrap justify-between gap-2 border-b border-emerald-900/40 py-1 last:border-0">
                    <span className="font-semibold">{t.name || t.slug}</span>
                    <span className="text-emerald-400">{t.protected_reason}</span>
                  </div>
                ))}
              </div>
            )}
            <label className="mt-3 flex items-center gap-2 text-xs font-semibold text-slate-300">
              <input
                type="checkbox"
                className="h-4 w-4 accent-rose-500"
                checked={cleanArch}
                onChange={(e) => setCleanArch(e.target.checked)}
                data-testid="cleanup-archives-check"
              />
              Svuota anche gli archivi collaterali (questionari, scansioni QR, consensi, posta inviata,
              sessioni, pagamenti di prova). Il registro accessi e i voucher restano.
            </label>
            <div className="mt-3 flex flex-wrap items-center gap-2">
              <Input
                className="h-10 max-w-[220px] bg-slate-900 text-slate-100"
                placeholder="Scrivi PULISCI"
                value={cleanWord}
                onChange={(e) => setCleanWord(e.target.value)}
                data-testid="cleanup-confirm-input"
              />
              <Button
                className="bg-rose-600 text-white hover:bg-rose-500"
                disabled={cleanWord.trim().toUpperCase() !== "PULISCI"}
                data-testid="cleanup-run-btn"
                onClick={async () => {
                  try {
                    const r = await client.post("/admin/cleanup/run", {
                      confirm: cleanWord,
                      archives: cleanArch,
                    });
                    toast.success(
                      `Eliminati ${r.data.tenants_deleted} locali · ${r.data.collections_dropped} raccolte dati`,
                    );
                    setClean(null);
                    setCleanWord("");
                    setSel(null);
                    await load();
                  } catch (e) {
                    toast.error(e?.response?.data?.detail || "Pulizia non riuscita");
                  }
                }}
              >
                <Trash2 className="mr-1.5 h-4 w-4" /> Elimina ora
              </Button>
              <button className="text-xs font-semibold text-slate-400" onClick={() => setClean(null)}>
                Annulla
              </button>
            </div>
          </Card>
        )}

        {showPwdBox && (
          <Card className="border-slate-800 bg-[#111827] p-4 text-slate-100" data-testid="console-password-box">
            <p className="text-sm font-semibold">Cambia la password della console</p>
            <p className="mt-1 text-xs text-slate-400">
              Almeno 12 caratteri, con una lettera e un numero. Dopo il cambio si chiudono tutte le
              sessioni aperte e i dispositivi ricordati: rientri con la password nuova e il codice email.
            </p>
            <div className="mt-3 grid gap-2 sm:grid-cols-2">
              <Input
                type="password"
                placeholder="Password attuale"
                autoComplete="current-password"
                className="bg-slate-900 text-slate-100"
                value={chgPwd.current_password}
                onChange={(e) => setChgPwd({ ...chgPwd, current_password: e.target.value })}
                data-testid="console-current-password-input"
              />
              <Input
                type="password"
                placeholder="Nuova password"
                autoComplete="new-password"
                className="bg-slate-900 text-slate-100"
                value={chgPwd.new_password}
                onChange={(e) => setChgPwd({ ...chgPwd, new_password: e.target.value })}
                data-testid="console-new-password-input"
              />
            </div>
            <Button
              className="mt-3 bg-amber-500 text-slate-950 hover:bg-amber-400"
              data-testid="console-save-password-btn"
              onClick={async () => {
                try {
                  await client.post("/admin/password/change", chgPwd);
                  toast.success("Password cambiata: rientra con quella nuova");
                  setChgPwd({ current_password: "", new_password: "" });
                  setShowPwdBox(false);
                  localStorage.removeItem("rh_admin");
                  localStorage.removeItem("rh_admin_device");
                  setToken("");
                } catch (e) {
                  toast.error(e?.response?.data?.detail || "Cambio password non riuscito");
                }
              }}
            >
              <KeyRound className="mr-1.5 h-4 w-4" /> Salva la password
            </Button>
          </Card>
        )}

        <Card className="overflow-hidden border-slate-800 bg-[#111827] p-0 text-slate-100" data-testid="console-soldi">
          <div className="grid grid-cols-2 divide-slate-800 sm:grid-cols-4 sm:divide-x">
            {soldi.map((x) => (
              <div key={x.id} className="p-4" data-testid={`soldi-${x.id}`}>
                <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">{x.l}</p>
                <p className="font-num mt-2 text-2xl font-bold text-emerald-400">{x.v}</p>
                <p className="mt-0.5 text-[11px] text-slate-400">{x.s}</p>
              </div>
            ))}
          </div>
          <p className="border-t border-slate-800 px-4 py-2 text-[11px] text-slate-500" data-testid="console-privacy-note">
            Sono i tuoi ricavi da abbonamenti Reprehendo. Gli incassi dei locali non sono e non saranno mai
            visibili in console: qui compaiono solo dati tecnici di configurazione.
          </p>
        </Card>

        <Card className="space-y-3 border-slate-800 bg-[#111827] p-5 text-slate-100" data-testid="console-todo">
          <div className="flex items-center gap-2">
            <ClipboardCheck className="h-4 w-4 text-amber-400" />
            <h2 className="font-head text-lg font-bold">Da fare oggi</h2>
            {daFare.length > 0 && (
              <span className="font-num rounded-full bg-amber-500 px-2 text-xs font-bold text-slate-950">{daFare.length}</span>
            )}
          </div>
          {daFare.length === 0 ? (
            <p className="text-sm text-slate-400" data-testid="todo-empty">
              Niente da fare adesso: nessuna prova in scadenza, nessun menu da caricare, nessuna attività sospesa.
            </p>
          ) : (
            <div className="space-y-2">
              {daFare.slice(0, 8).map((u) => (
                <button
                  key={u.id}
                  data-testid={`todo-${u.id}`}
                  onClick={() => {
                    setTab(u.tab);
                    if (u.tid) setSel(u.tid);
                  }}
                  className={`flex w-full items-center gap-3 rounded-lg border px-3 py-2.5 text-left text-xs font-semibold transition-colors hover:brightness-125 ${TONI[u.tono]}`}
                >
                  <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
                  <span className="min-w-0 flex-1">{u.testo}</span>
                  <span className="hidden shrink-0 opacity-70 sm:inline">{u.azione} →</span>
                </button>
              ))}
              {daFare.length > 8 && <p className="text-[11px] text-slate-400">e altre {daFare.length - 8} cose nelle schede.</p>}
            </div>
          )}
        </Card>

        {urgenze.length > 0 && (
          <div className="flex flex-wrap gap-2" data-testid="console-urgent-bar">
            {urgenze.map((u) => (
              <button
                key={u.id}
                onClick={() => setTab(u.tab)}
                className="flex min-h-[44px] items-center gap-2 rounded-lg border border-amber-500/25 bg-amber-500/10 px-3 py-2 text-left text-xs font-semibold text-amber-300 transition-colors hover:bg-amber-500/20"
                data-testid={`urgent-${u.id}`}
              >
                <AlertTriangle className="h-3.5 w-3.5 shrink-0" /> {u.testo}
              </button>
            ))}
          </div>
        )}

        <button
          onClick={() => { setTab("prove"); setTimeout(() => document.querySelector("[data-testid='console-quiz-funnel']")?.scrollIntoView({ behavior: "smooth", block: "start" }), 120); }}
          className="flex w-full flex-wrap items-center gap-x-5 gap-y-2 rounded-xl border border-slate-800 bg-[#111827] px-4 py-3 text-left transition-colors hover:border-amber-500/40"
          data-testid="console-quiz-riepilogo"
        >
          <span className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">
            <Play className="h-3.5 w-3.5" /> Test attività · 30 giorni
          </span>
          <span className="font-num text-sm font-bold text-slate-100">{funnel?.sessions ?? 0} hanno risposto</span>
          <span className="font-num text-sm font-bold text-emerald-400">{funnel?.completed ?? 0} completati</span>
          <span className="font-num text-sm text-slate-400">{funnel?.peeked ?? 0} solo sbirciato</span>
          {funnel?.worst_step?.label && (
            <span className="text-sm text-amber-300">si fermano su: {funnel.worst_step.label}</span>
          )}
          <span className="ml-auto text-xs text-slate-500">vedi dettaglio →</span>
        </button>

        <div className="grid grid-cols-3 gap-1.5 rounded-xl border border-slate-800 bg-[#111827] p-1.5 sm:grid-cols-7" data-testid="console-tabs">
          {TABS.map((tb) => (
            <button
              key={tb.id}
              onClick={() => setTab(tb.id)}
              className={`flex min-h-[44px] flex-col items-center justify-center gap-0.5 rounded-lg px-1 text-[11px] font-semibold transition-colors sm:flex-row sm:gap-2 sm:text-sm ${
                tab === tb.id ? "bg-amber-500 text-slate-950" : "text-slate-400 hover:bg-slate-800 hover:text-slate-200"
              }`}
              data-testid={`tab-${tb.id}`}
            >
              <tb.icon className="h-4 w-4" />
              {tb.label}
            </button>
          ))}
        </div>

        <div className={tab === "demo" ? "" : "hidden"}>
          <RichiesteDemo client={client} />
        </div>

        <div className={tab === "avvio" ? "space-y-4" : "hidden"}>
          <StatoLocali client={client} />
          <AvvioLocali client={client} />
        </div>

        <div className={`grid grid-cols-2 gap-3 sm:grid-cols-5 ${tab === "clienti" ? "" : "hidden"}`} data-testid="console-totals">
          {[["Clienti", data.totals.clients], ["Attivi", data.totals.active], ["Paganti", data.totals.paying],
            ["Sospesi", data.totals.suspended], ["Ricavo mensile", eur(data.totals.mrr)]].map(([l, val]) => (
            <Card key={l} className="border-slate-800 bg-[#111827] p-4 text-slate-100">
              <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">{l}</p>
              <p className="font-num mt-1.5 text-xl font-bold">{val}</p>
            </Card>
          ))}
        </div>

        <Card className={`space-y-3 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "clienti" ? "" : "hidden"}`} data-testid="console-scadenze">
          <h2 className="font-head flex items-center gap-2 text-lg font-bold">
            <CalendarClock className="h-4 w-4" /> Prossime scadenze
          </h2>
          {scadenze.length === 0 ? (
            <p className="text-sm text-slate-400">Nessun cliente con scadenza registrata.</p>
          ) : (
            <ul className="space-y-1.5" data-testid="scadenze-lista">
              {scadenze.map((t) => (
                <li key={t.id} className="flex flex-wrap items-center gap-x-2 gap-y-1 border-b border-slate-800 pb-1.5 text-xs last:border-0">
                  <button
                    className="font-semibold text-slate-200 underline-offset-2 hover:underline"
                    data-testid={`scadenza-${t.slug}`}
                    onClick={() => { setTab("clienti"); apriGestione(t.id); }}
                  >
                    {t.name}
                  </button>
                  <span className="text-slate-500">{t.plan_name}</span>
                  <span className="font-num text-slate-400">scade il {dataIt(t.current_period_end)}</span>
                  <GiorniBadge t={t} />
                </li>
              ))}
            </ul>
          )}
          <p className="text-[11px] text-slate-500">
            Ti arriva anche un'email ogni mattina quando un abbonamento scade entro 7 giorni.
          </p>
        </Card>

        <Card className={`space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "clienti" || tab === "demo" ? "" : "hidden"}`} data-testid="console-clients">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <h2 className="font-head flex items-center gap-2 text-lg font-bold">
              {tab === "demo"
                ? <><FlaskConical className="h-4 w-4" /> Demo, vetrine e prove interne</>
                : <><Users className="h-4 w-4" /> Clienti registrati</>}
            </h2>
            <div className="relative">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input className="h-9 w-56 pl-9" placeholder="Cerca cliente" value={q} onChange={(e) => setQ(e.target.value)} data-testid="client-search-input" />
            </div>
          </div>

          <div className={`flex flex-wrap gap-1.5 ${tab === "demo" ? "hidden" : ""}`} data-testid="client-groups">
            {GRUPPI.map((g) => {
              const n = g.id === "tutti" ? sezione.length : sezione.filter((t) => t.kind === g.id).length;
              return (
                <button
                  key={g.id}
                  data-testid={`group-${g.id}`}
                  onClick={() => { setGruppo(g.id); setSel(null); }}
                  className={`rounded-full px-3 py-1.5 text-xs font-semibold transition-colors ${
                    gruppo === g.id ? "bg-amber-500 text-slate-950" : "bg-slate-800 text-slate-300 hover:bg-slate-700"
                  }`}
                >
                  {g.l} <span className="font-num opacity-70">{n}</span>
                </button>
              );
            })}
          </div>

          <div className={`flex flex-wrap items-end gap-2 rounded-md bg-slate-900/60 p-3 ${tab === "demo" ? "hidden" : ""}`}>
            <span className="w-full text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">Nuova attività</span>
            <Input className="h-9 w-44" placeholder="Nome locale" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="new-client-name-input" />
            <Input className="h-9 w-36" placeholder="P.IVA" value={form.vat} onChange={(e) => setForm({ ...form, vat: e.target.value })} data-testid="new-client-vat-input" />
            <Input className="h-9 w-36" placeholder="Telefono" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="new-client-phone-input" />
            <Input className="h-9 w-36" placeholder="Referente" value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} data-testid="new-client-contact-input" />
            {PLANS.map((pl) => (
              <Button key={pl} size="sm" variant={form.plan === pl ? "default" : "outline"} onClick={() => setForm({ ...form, plan: pl })} data-testid={`new-client-plan-${pl}`}>
                {PLAN_NAME[pl]}
              </Button>
            ))}
            <Input className="h-9 w-16" type="number" min="1" value={form.months} onChange={(e) => setForm({ ...form, months: Number(e.target.value) })} data-testid="new-client-months-input" />
            <span className="text-xs text-slate-400">mesi</span>
            <label className="flex w-full cursor-pointer items-center gap-2 text-[11px] text-slate-400">
              <input
                type="checkbox"
                className="h-3.5 w-3.5 accent-sky-500"
                checked={form.allow_dup_vat}
                onChange={(e) => setForm({ ...form, allow_dup_vat: e.target.checked })}
                data-testid="new-client-dup-vat-check"
              />
              Seconda sede della stessa impresa (consente una P.IVA già registrata)
            </label>
            <Button
              size="sm"
              data-testid="create-client-btn"
              onClick={async () => {
                if (!form.name.trim()) return toast.error("Inserisci il nome del locale");
                const r = await act(() => client.post("/admin/tenants", form), "Attività creata");
                if (r) {
                  setNewCode(r);
                  setForm({ name: "", vat: "", phone: "", contact: "", plan: "free", months: 12, allow_dup_vat: false });
                }
              }}
            >
              <Plus className="mr-1 h-3.5 w-3.5" /> Crea
            </Button>
          </div>

          {newCode && (
            <div className="rounded-md border-2 border-emerald-500 bg-emerald-50 p-4" data-testid="new-client-credentials">
              <p className="text-sm font-semibold text-emerald-900">Credenziali di {newCode.name} — mostrale solo ora</p>
              <p className="font-num mt-2 text-sm">
                Attività: <span className="font-bold">{newCode.slug}</span> · Codice:{" "}
                <span className="font-bold tracking-[0.2em]">{newCode.access_code}</span>
              </p>
              <div className="mt-3 flex gap-2">
                <Button
                  size="sm"
                  data-testid="copy-credentials-btn"
                  onClick={() => {
                    navigator.clipboard?.writeText(`Attività: ${newCode.slug} — Codice: ${newCode.access_code}`);
                    toast.success("Credenziali copiate");
                  }}
                >
                  <Copy className="mr-1 h-3.5 w-3.5" /> Copia
                </Button>
                <Button size="sm" variant="outline" onClick={() => setNewCode(null)} data-testid="dismiss-credentials-btn">
                  Ho salvato
                </Button>
              </div>
            </div>
          )}

          <div className="hidden overflow-x-auto sm:block">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-[10px] uppercase tracking-[0.16em] text-slate-400">
                  <th className="py-2 pr-3 font-bold">Attività</th>
                  <th className="py-2 pr-3 font-bold">Piano</th>
                  <th className="py-2 pr-3 font-bold">Attivo dal</th>
                  <th className="py-2 pr-3 font-bold">Scadenza</th>
                  <th className="py-2 pr-3 font-bold">Stato</th>
                  <th className="py-2 pr-3 font-bold">Uso</th>
                  <th className="py-2 font-bold"></th>
                </tr>
              </thead>
              <tbody>
                {list.map((t) => (
                  <tr key={t.id} className="border-b border-slate-800 last:border-0" data-testid={`client-${t.slug}`}>
                    <td className="py-2.5 pr-3">
                      <p className="font-semibold">{t.name}</p>
                      <p className="font-num text-[11px] text-slate-400">{t.slug} · {t.contact || t.phone || "—"}</p>
                      <p className="font-num text-[11px] text-slate-500" data-testid={`vat-${t.slug}`}>
                        {t.vat ? `P.IVA ${t.vat}` : "P.IVA mancante"}
                        {t.sede_extra && <span className="ml-1 text-sky-400">· seconda sede</span>}
                      </p>
                    </td>
                    <td className="py-2.5 pr-3">{t.plan_name}</td>
                    <td className="py-2.5 pr-3 font-num text-slate-400" data-testid={`attivo-dal-${t.slug}`}>
                      {dataIt(t.activated_at || (t.kind === "autorizzato" ? t.created_at : null))}
                    </td>
                    <td className="py-2.5 pr-3 font-num text-slate-400">
                      {t.current_period_end ? new Date(t.current_period_end).toLocaleDateString("it-IT") : "—"}
                      <span className="ml-2 inline-block"><GiorniBadge t={t} /></span>
                    </td>
                    <td className="py-2.5 pr-3">
                      <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${t.suspended ? "border border-rose-500/30 bg-rose-500/15 text-rose-400" : "border border-emerald-500/30 bg-emerald-500/15 text-emerald-400"}`}>
                        {t.suspended ? "sospeso" : "attivo"}
                      </span>
                    </td>
                    <td className="py-2.5 pr-3 font-num text-[11px] text-slate-400">
                      {t.usage.menu} piatti · {t.usage.tables} tavoli · {t.usage.users} utenti
                      <span className="ml-2 rounded-full bg-slate-800 px-2 py-0.5 text-[10px] font-bold not-italic text-slate-300">
                        {t.kind === "pagante" ? "pagante" : t.kind === "prova" ? "in prova"
                          : t.kind === "demo" ? (t.interno ? "prova interna" : "vetrina demo") : "autorizzato"}
                      </span>
                    </td>
                    <td className="py-2.5 text-right">
                      <Button size="sm" variant={sel === t.id ? "default" : "outline"} data-testid={`manage-client-${t.slug}`} onClick={() => apriGestione(t.id)}>
                        Gestisci
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {list.length === 0 && <p className="py-4 text-sm text-slate-400">Nessuna attività registrata.</p>}
          </div>

          {/* Su telefono la tabella non si legge: una scheda per locale, con il pulsante sempre in vista */}
          <div className="space-y-3 sm:hidden">
            {list.map((t) => (
              <div key={t.id} className="rounded-lg border border-slate-800 p-3" data-testid={`client-card-${t.slug}`}>
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    <p className="truncate font-semibold">{t.name}</p>
                    <p className="font-num truncate text-[11px] text-slate-400">{t.slug}</p>
                    <p className="font-num truncate text-[11px] text-slate-500">{t.vat ? `P.IVA ${t.vat}` : "P.IVA mancante"}</p>
                    <span className={`mt-1 inline-block rounded-full px-2 py-0.5 text-[10px] font-bold ${
                      t.kind === "pagante" ? "bg-emerald-500/15 text-emerald-300"
                        : t.kind === "prova" ? "bg-amber-500/15 text-amber-300"
                        : t.kind === "demo" ? "bg-slate-700 text-slate-300"
                        : "bg-sky-500/15 text-sky-300"}`} data-testid={`kind-${t.slug}`}>
                      {t.kind === "pagante" ? "pagante" : t.kind === "prova" ? "in prova"
                        : t.kind === "demo" ? (t.interno ? "prova interna" : "vetrina demo") : "autorizzato da te"}
                    </span>
                  </div>
                  <span className={`shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold ${t.suspended ? "border border-rose-500/30 bg-rose-500/15 text-rose-400" : "border border-emerald-500/30 bg-emerald-500/15 text-emerald-400"}`}>
                    {t.suspended ? "sospeso" : "attivo"}
                  </span>
                </div>
                <p className="mt-1.5 text-[11px] text-slate-600">
                  {t.plan_name}
                  {t.current_period_end && ` · fino al ${new Date(t.current_period_end).toLocaleDateString("it-IT")}`}
                </p>
                <p className="mt-1 flex items-center gap-2 text-[11px] text-slate-500">
                  Attivo dal {dataIt(t.activated_at || (t.kind === "autorizzato" ? t.created_at : null))}
                  <GiorniBadge t={t} />
                </p>
                <p className="font-num text-[11px] text-slate-400">
                  {t.usage.menu} piatti · {t.usage.tables} tavoli · {t.usage.users} utenti
                </p>
                <Button
                  className="mt-3 h-11 w-full"
                  variant={sel === t.id ? "default" : "outline"}
                  data-testid={`manage-mobile-${t.slug}`}
                  onClick={() => apriGestione(t.id)}
                >
                  {sel === t.id ? "Chiudi" : "Gestisci"}
                </Button>
              </div>
            ))}
            {list.length === 0 && <p className="py-4 text-sm text-slate-400">Nessuna attività registrata.</p>}
          </div>
        </Card>

        {current && (
          <Card ref={panelRef} className={`scroll-mt-4 space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "clienti" || tab === "demo" ? "" : "hidden"}`} data-testid="client-panel">
            <h2 className="font-head flex items-center gap-2 text-lg font-bold">
              <Building2 className="h-4 w-4" /> {current.name}
            </h2>

            <div className="flex flex-wrap items-center gap-2 rounded-md bg-slate-900/60 p-3">
              <span className="text-xs text-slate-400">
                {current.kind === "demo" ? "Sta nella sezione Demo e prove interne." : "Sta nell'elenco dei clienti."}
              </span>
              {current.demo ? (
                <span className="text-[11px] text-slate-500">La vetrina d'esempio resta sempre qui.</span>
              ) : (
                <Button
                  size="sm"
                  variant="outline"
                  data-testid="client-toggle-interno"
                  onClick={() => act(() => client.post(`/admin/tenants/${current.id}/interno`, { interno: current.kind !== "demo" }),
                                     current.kind === "demo" ? `${current.name} è tornato tra i clienti` : `${current.name} spostato nelle demo`)}
                >
                  <FlaskConical className="mr-1 h-3.5 w-3.5" />
                  {current.kind === "demo" ? "Riporta tra i clienti" : "Sposta nelle demo"}
                </Button>
              )}
            </div>

            <AccessoLocale client={client} tenant={current} />
            <SchedaCliente client={client} tenant={current} />
            <MenuLocale client={client} tenant={current} />

            <div className="space-y-2 rounded-md bg-slate-900/60 p-3" data-testid="manuali-locale">
              <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-slate-400">
                Manda i manuali al locale{current.email ? ` · ${current.email}` : " (nessuna email registrata)"}
              </p>
              <div className="flex flex-wrap gap-2">
                {[["cassa", "Cassa fiscale"], ["stampanti", "Stampanti"], ["cassa,stampanti", "Tutti e due"]].map(([docs, label]) => (
                  <Button
                    key={docs}
                    size="sm"
                    variant="outline"
                    data-testid={`manuali-${docs.replace(",", "-")}`}
                    onClick={() => act(() => client.post(`/admin/tenants/${current.id}/manuali-email`,
                                                         { docs: docs.split(",") }),
                                       `Manuali inviati a ${current.name}`)}
                  >
                    <FileText className="mr-1 h-3.5 w-3.5" /> {label}
                  </Button>
                ))}
                <a className="inline-flex h-8 items-center gap-1 rounded-md border border-slate-700 px-2.5 text-xs font-semibold text-slate-300"
                   href={`${API}/public/kit/cassa-setup.pdf`} target="_blank" rel="noreferrer" data-testid="manuale-cassa-apri">
                  Apri cassa
                </a>
                <a className="inline-flex h-8 items-center gap-1 rounded-md border border-slate-700 px-2.5 text-xs font-semibold text-slate-300"
                   href={`${API}/public/kit/stampanti.pdf`} target="_blank" rel="noreferrer" data-testid="manuale-stampanti-apri">
                  Apri stampanti
                </a>
              </div>
            </div>

            <div className="flex flex-wrap items-center gap-2">
              <span className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">Piano</span>
              <Input className="h-9 w-16" type="number" min="1" value={months} onChange={(e) => setMonths(Number(e.target.value))} data-testid="client-months-input" />
              <span className="text-xs text-slate-400">mesi</span>
              {PLANS.map((pl) => (
                <Button
                  key={pl}
                  size="sm"
                  variant={current.plan === pl ? "default" : "outline"}
                  data-testid={`client-set-plan-${pl}`}
                  onClick={() => act(() => client.post(`/admin/tenants/${current.id}/plan`, { plan: pl, months }), `${PLAN_NAME[pl]} autorizzato per ${current.name}`)}
                >
                  {PLAN_NAME[pl]}
                </Button>
              ))}
              <RegalaMesi
                tenant={current}
                testid="client-gift-pro"
                onRegala={(mesi) =>
                  act(() => client.post(`/admin/tenants/${current.id}/gift`, { months: mesi }),
                      `${mesi} mesi Pro regalati a ${current.name}: email di avviso inviata`)}
              />
              <Button
                size="sm"
                variant="outline"
                data-testid="client-kit-email"
                onClick={() => act(() => client.post("/admin/kit/email", { name: current.name }), "Materiale inviato per email")}
              >
                Materiale per email
              </Button>
              <Button
                size="sm"
                variant="outline"
                data-testid="client-card-link"
                onClick={() => window.open(`/biglietto?locale=${encodeURIComponent(current.name)}`, "_blank")}
              >
                Biglietto della prova
              </Button>
            </div>

            {current.demo && (
              <div className="flex flex-wrap items-center gap-2 border-t border-slate-800 pt-3">
                <span className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">Vetrina</span>
                <p className="w-full text-[11px] text-slate-500 sm:w-auto sm:flex-1">
                  In vetrina si naviga tutto ma non si modifica nulla: i dati d'esempio restano puliti.
                </p>
                {current.showcase ? (
                  <Button size="sm" variant="outline" data-testid="client-showcase-off-btn"
                          onClick={() => act(() => client.post(`/admin/tenants/${current.id}/showcase`, { on: false }), "Demo di nuovo modificabile")}>
                    <Play className="mr-1 h-3.5 w-3.5" /> Rendi modificabile
                  </Button>
                ) : (
                  <Button size="sm" variant="outline" data-testid="client-showcase-on-btn"
                          onClick={() => act(() => client.post(`/admin/tenants/${current.id}/showcase`, { on: true }), "Demo bloccata in sola visione")}>
                    <Eye className="mr-1 h-3.5 w-3.5" /> Blocca in sola visione
                  </Button>
                )}
                <Button size="sm" variant="ghost" className="text-xs text-slate-400" data-testid="client-showcase-link-btn"
                        onClick={() => {
                          navigator.clipboard.writeText(`${window.location.origin}/demo/sala?locale=${current.slug}&vista=solo-lettura`);
                          toast.success("Link vetrina copiato");
                        }}>
                  <Copy className="mr-1 h-3.5 w-3.5" /> Copia link vetrina
                </Button>
              </div>
            )}

            {current.demo && <VetrinaAdmin tenant={current} client={client} onDone={load} />}

            <div className="flex flex-wrap items-center gap-2 border-t border-slate-800 pt-3">
              <span className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">Accesso</span>
              <Input className="h-9 w-52" placeholder="Motivo sospensione" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="client-reason-input" />
              {current.suspended ? (
                <Button size="sm" data-testid="client-unsuspend-btn" onClick={() => act(() => client.post(`/admin/tenants/${current.id}/suspend`, { suspended: false }), "Servizio riattivato")}>
                  <Play className="mr-1 h-3.5 w-3.5" /> Riattiva
                </Button>
              ) : (
                <Button size="sm" variant="destructive" data-testid="client-suspend-btn" onClick={() => act(() => client.post(`/admin/tenants/${current.id}/suspend`, { suspended: true, reason }), "Servizio sospeso")}>
                  <Ban className="mr-1 h-3.5 w-3.5" /> Sospendi
                </Button>
              )}
              <Button
                size="sm"
                variant="outline"
                data-testid="client-newcode-btn"
                onClick={async () => {
                  const r = await act(() => client.patch(`/admin/tenants/${current.id}`, { new_code: true }), "Nuovo codice generato");
                  if (r) setNewCode(r);
                }}
              >
                <KeyRound className="mr-1 h-3.5 w-3.5" /> Nuovo codice
              </Button>
              <span className="font-num text-xs text-slate-400">codice attuale {current.code_hint}</span>
              <Button
                size="sm"
                variant="ghost"
                className="ml-auto text-rose-600"
                data-testid="client-delete-btn"
                onClick={() => act(() => client.delete(`/admin/tenants/${current.id}`), "Attività eliminata")}
              >
                <Trash2 className="mr-1 h-3.5 w-3.5" /> Elimina attività
              </Button>
            </div>

            {scheda && (
              <div className="space-y-4 border-t border-slate-800 pt-4" data-testid="client-scheda">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-xs font-bold uppercase tracking-[0.16em] text-slate-400">Pronto per partire</span>
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold uppercase ${scheda.ready ? "bg-emerald-500/15 text-emerald-400" : "bg-amber-500/15 text-amber-300"}`} data-testid="scheda-ready">
                    {scheda.ready ? "tutto configurato" : (() => {
                      const n = scheda.checklist.filter((c) => !c.done).length;
                      return n === 1 ? "1 cosa da fare" : `${n} cose da fare`;
                    })()}
                  </span>
                  <a
                    className="ml-auto flex items-center gap-1 text-[11px] font-semibold text-sky-400 hover:underline"
                    href={`/carta/${current.slug}`}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="scheda-carta-link"
                  >
                    Carta del cliente <ExternalLink className="h-3 w-3" />
                  </a>
                </div>

                <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
                  {scheda.checklist.map((c) => (
                    <div key={c.id} className="flex items-start gap-2 rounded-lg border border-slate-800 p-3" data-testid={`scheda-step-${c.id}`}>
                      {c.done ? (
                        <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
                      ) : (
                        <Circle className="mt-0.5 h-4 w-4 shrink-0 text-slate-600" />
                      )}
                      <span className="min-w-0">
                        <span className="block text-sm font-semibold">{c.label}</span>
                        <span className="block truncate text-[11px] text-slate-400">{c.hint}</span>
                      </span>
                    </div>
                  ))}
                </div>

                <ConsoleAccessi client={client} slug={current.slug} />

                <div className="rounded-lg border border-slate-800 p-3" data-testid="scheda-import">                  <p className="flex items-center gap-2 text-sm font-semibold">
                    <UploadCloud className="h-4 w-4 text-sky-400" /> Carica il menu di {current.name}
                  </p>
                  <p className="mt-1 text-[11px] text-slate-400">
                    PDF con testo, Excel o CSV, massimo 8 MB. Prima vedi l'anteprima, poi confermi. I PDF scansionati (foto) non sono leggibili.
                  </p>
                  <div className="mt-2 flex flex-wrap items-center gap-2">
                    <a
                      className="inline-flex h-8 items-center gap-1 rounded-md border border-slate-700 px-2.5 text-xs font-semibold text-slate-300"
                      href="/menu-mezzaluna.csv"
                      download="menu-mezzaluna.csv"
                      data-testid="scarica-menu-mezzaluna"
                    >
                      <FileText className="h-3.5 w-3.5" /> Scarica il listino Mezzaluna (179 voci)
                    </a>
                    <a
                      className="inline-flex h-8 items-center gap-1 rounded-md border border-slate-700 px-2.5 text-xs font-semibold text-slate-300"
                      href="/modello-listino.csv"
                      download="modello-listino.csv"
                      data-testid="scarica-modello-listino"
                    >
                      <FileText className="h-3.5 w-3.5" /> Modello vuoto
                    </a>
                  </div>
                  <div className="mt-3 flex flex-wrap items-center gap-2">
                    <input
                      type="file"
                      accept=".pdf,.csv,.xlsx,.xlsm"
                      data-testid="scheda-import-file"
                      className="max-w-full text-xs text-slate-300"
                      onChange={(e) => {
                        setImpFile(e.target.files?.[0] || null);
                        setImp(null);
                      }}
                    />
                    <Button
                      size="sm"
                      variant="outline"
                      disabled={!impFile || impBusy}
                      data-testid="scheda-import-preview"
                      onClick={async () => {
                        setImpBusy(true);
                        const fd = new FormData();
                        fd.append("file", impFile);
                        try {
                          const r = await client.post(`/admin/tenants/${current.id}/menu-import?dry_run=true&mode=add`, fd);
                          setImp(r.data);
                        } catch (e) {
                          toast.error(e?.response?.data?.detail || "File non leggibile");
                        } finally {
                          setImpBusy(false);
                        }
                      }}
                    >
                      Anteprima
                    </Button>
                    {imp && (
                      <>
                        <Button
                          size="sm"
                          disabled={impBusy}
                          data-testid="scheda-import-add"
                          onClick={async () => {
                            setImpBusy(true);
                            const fd = new FormData();
                            fd.append("file", impFile);
                            try {
                              const r = await client.post(`/admin/tenants/${current.id}/menu-import?dry_run=false&mode=add`, fd);
                              toast.success(`${r.data.imported} piatti aggiunti a ${current.name}${r.data.updated ? ` · ${r.data.updated} prezzi completati` : ""}`);
                              setImp(null);
                              setImpFile(null);
                              setSel(current.id);
                              await load();
                            } catch (e) {
                              toast.error(e?.response?.data?.detail || "Import non riuscito");
                            } finally {
                              setImpBusy(false);
                            }
                          }}
                        >
                          Aggiungi {imp.will_insert} piatti
                        </Button>
                        <Button
                          size="sm"
                          variant="destructive"
                          disabled={impBusy}
                          data-testid="scheda-import-replace"
                          onClick={async () => {
                            if (!window.confirm(`Sostituisco tutto il menu di ${current.name} con ${imp.count} piatti? Il listino attuale viene cancellato.`)) return;
                            setImpBusy(true);
                            const fd = new FormData();
                            fd.append("file", impFile);
                            try {
                              const r = await client.post(`/admin/tenants/${current.id}/menu-import?dry_run=false&mode=replace`, fd);
                              toast.success(`Menu di ${current.name} sostituito: ${r.data.imported} piatti`);
                              setImp(null);
                              setImpFile(null);
                              setSel(current.id);
                              await load();
                            } catch (e) {
                              toast.error(e?.response?.data?.detail || "Import non riuscito");
                            } finally {
                              setImpBusy(false);
                            }
                          }}
                        >
                          Sostituisci il menu
                        </Button>
                      </>
                    )}
                  </div>
                  {impBusy && (
                    <p className="mt-2 flex items-center gap-2 text-[11px] font-semibold text-sky-300" data-testid="import-in-corso">
                      <span className="h-2 w-2 animate-pulse rounded-full bg-sky-400" />
                      Sto lavorando sul listino… resta su questa pagina, ci vogliono pochi secondi.
                    </p>
                  )}
                  {imp && (
                    <div className="mt-3 rounded-md bg-slate-900/60 p-3" data-testid="scheda-import-preview-box">
                      <p className="font-num text-xs text-slate-300">
                        {imp.count} piatti trovati · {imp.duplicates} già presenti · {imp.will_insert} da inserire
                        {imp.errors?.length > 0 && ` · ${imp.errors.length} righe scartate`}
                      </p>
                      <div className="mt-2 max-h-40 overflow-y-auto">
                        {imp.rows.slice(0, 40).map((r, i) => (
                          <p key={`${r.name}-${i}`} className="font-num text-[11px] text-slate-400">
                            {r.category} · {r.name} · {eur(r.price)} · {r.department}
                          </p>
                        ))}
                      </div>
                      {imp.errors?.length > 0 && (
                        <p className="mt-2 text-[11px] text-amber-400">{imp.errors.slice(0, 3).join(" · ")}</p>
                      )}
                    </div>
                  )}
                </div>

                <div className="rounded-lg border border-slate-800 p-3">
                  <p className="flex items-center gap-2 text-sm font-semibold">
                    <StickyNote className="h-4 w-4 text-amber-400" /> Note private su questo locale
                  </p>
                  <textarea
                    className="mt-2 h-20 w-full rounded-md border border-slate-800 bg-[#0b1220] p-2 text-sm text-slate-200"
                    placeholder="Es. il tecnico della cassa richiama martedì · vogliono il menu fisso solo la domenica"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    data-testid="scheda-note-input"
                  />
                  <Button
                    size="sm"
                    className="mt-2"
                    data-testid="scheda-note-save"
                    onClick={() => act(() => client.patch(`/admin/tenants/${current.id}`, { notes: note }), "Note salvate")}
                  >
                    Salva le note
                  </Button>
                </div>

                <p className="font-num text-[11px] text-slate-500">
                  {scheda.counts.menu} piatti · {scheda.counts.tables} tavoli · {scheda.counts.staff} persone ·
                  {" "}funzioni attive: {scheda.modules.length}
                  {current.last_access && ` · ultimo accesso ${new Date(current.last_access).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}`}
                </p>
              </div>
            )}
          </Card>
        )}

        <Card className={`space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "voucher" ? "" : "hidden"}`} data-testid="console-voucher-card">
          <div className="flex items-center gap-2">
            <Ticket className="h-4 w-4" />
            <h2 className="font-head text-lg font-bold">Voucher usa e getta</h2>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="w-full text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">Tipo di voucher — scegline uno</span>
            {KINDS.map((k) => (
              <Button key={k.id} size="sm" variant={v.kind === k.id ? "default" : "outline"} onClick={() => setV({ ...v, kind: k.id })} data-testid={`voucher-kind-${k.id}`}>
                {k.label}
              </Button>
            ))}
            {v.kind === "free_months" ? (
              <>
                {["standard", "pro"].map((pl) => (
                  <Button key={pl} size="sm" variant={v.plan === pl ? "default" : "outline"} onClick={() => setV({ ...v, plan: pl })} data-testid={`voucher-plan-${pl}`}>
                    {PLAN_NAME[pl]}
                  </Button>
                ))}
                <Input type="number" min="1" className="h-9 w-16" value={v.months} onChange={(e) => setV({ ...v, months: Number(e.target.value) })} data-testid="voucher-months-input" />
                <span className="text-xs text-slate-400">mesi gratis</span>
              </>
            ) : (
              <>
                <Input type="number" min="1" className="h-9 w-24" value={v.value} onChange={(e) => setV({ ...v, value: Number(e.target.value) })} data-testid="voucher-value-input" />
                <span className="text-xs text-slate-400">{v.kind === "percent" ? "% di sconto" : "€ di sconto"}</span>
              </>
            )}
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <span className="w-full text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">Campagna, quantità e validità</span>
            {LABELS.map((l) => (
              <button
                key={l}
                data-testid={`voucher-label-${l.split(" ")[0].toLowerCase()}`}
                onClick={() => setV({ ...v, label: l })}
                className={`rounded-full px-2.5 py-1 text-xs font-medium ${v.label === l ? "bg-slate-900 text-white" : "border border-slate-700 bg-slate-800 text-slate-300"}`}
              >
                {l}
              </button>
            ))}
            <Input className="h-9 w-40" placeholder="Campagna" value={v.label} onChange={(e) => setV({ ...v, label: e.target.value })} data-testid="voucher-label-input" />
            <Input type="number" min="1" className="h-9 w-16" value={v.quantity} onChange={(e) => setV({ ...v, quantity: Number(e.target.value) })} data-testid="voucher-quantity-input" />
            <span className="text-xs text-slate-400">codici</span>
            <Input type="number" min="1" className="h-9 w-16" value={v.expires_days} onChange={(e) => setV({ ...v, expires_days: Number(e.target.value) })} data-testid="voucher-expiry-input" />
            <span className="text-xs text-slate-400">giorni</span>
            <Button data-testid="create-voucher-btn" onClick={() => act(() => client.post("/admin/vouchers", v), "Voucher generati")}>
              Genera
            </Button>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b text-left text-[10px] uppercase tracking-[0.16em] text-slate-400">
                  <th className="py-2 pr-3 font-bold">Codice</th>
                  <th className="py-2 pr-3 font-bold">Tipo</th>
                  <th className="py-2 pr-3 font-bold">Campagna</th>
                  <th className="py-2 pr-3 font-bold">Scadenza</th>
                  <th className="py-2 pr-3 font-bold">Stato</th>
                  <th className="py-2 font-bold"></th>
                </tr>
              </thead>
              <tbody>
                {vouchers.map((x) => (
                  <tr key={x.id} className="border-b border-slate-800 last:border-0" data-testid={`voucher-${x.code}`}>
                    <td className="py-2.5 pr-3 font-num font-bold">{x.code}</td>
                    <td className="py-2.5 pr-3 text-slate-600">
                      {x.kind === "free_months" ? `${x.months} mesi ${PLAN_NAME[x.plan]}` : x.kind === "percent" ? `-${x.value}%` : `-${eur(x.value)}`}
                    </td>
                    <td className="py-2.5 pr-3 text-slate-400">{x.label}</td>
                    <td className="py-2.5 pr-3 font-num text-slate-400">{new Date(x.expires_at).toLocaleDateString("it-IT")}</td>
                    <td className="py-2.5 pr-3">
                      <span className={`rounded-full px-2 py-0.5 text-[11px] font-semibold ${x.used ? "bg-slate-200 text-slate-600" : "border border-emerald-500/30 bg-emerald-500/15 text-emerald-400"}`}>
                        {x.used ? "usato" : "valido"}
                      </span>
                    </td>
                    <td className="py-2.5 text-right">
                      <button className="mr-2 text-slate-400 hover:text-slate-900" data-testid={`copy-voucher-${x.code}`} onClick={() => navigator.clipboard?.writeText(x.code)}>
                        <Copy className="h-3.5 w-3.5" />
                      </button>
                      <button className="text-rose-600" data-testid={`delete-voucher-${x.code}`} onClick={() => act(() => client.delete(`/admin/vouchers/${x.id}`), "Voucher eliminato")}>
                        <Trash2 className="h-3.5 w-3.5" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {vouchers.length === 0 && <p className="py-4 text-sm text-slate-400">Nessun voucher generato.</p>}
          </div>
        </Card>

        <Card className={`space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "prove" ? "" : "hidden"}`} data-testid="console-trials">
          <div>
            <h2 className="font-head text-lg font-bold">Prove gratuite</h2>
            <p className="text-xs text-slate-400">
              Alla scadenza il locale passa al piano Gratuito e continua a lavorare. I dati restano
              {" "}{trials?.keep_days ?? 30} giorni, poi vengono eliminati (con avviso via email 3 giorni prima).
            </p>
          </div>

          <div className="grid grid-cols-3 gap-3" data-testid="trials-totals">
            {[["In corso", trials?.totals?.active ?? 0], ["Scadute", trials?.totals?.expired ?? 0],
              ["Archiviate", trials?.totals?.archived ?? 0]].map(([l, n]) => (
              <div key={l} className="rounded-md border border-slate-800 p-3">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">{l}</p>
                <p className="mt-2 text-base font-bold">{n}</p>
              </div>
            ))}
          </div>

          <div className="space-y-2">
            {(scans?.rows || []).some((r) => r.opened > 0) && (
              <div className="mb-4 rounded-md border border-slate-800 bg-slate-900/60 p-3" data-testid="scans-panel">
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">
                  Chi ha inquadrato · ultimi {scans.days} giorni
                </p>
                <div className="mt-2 space-y-1.5">
                  {scans.rows.filter((r) => r.opened > 0).map((r) => (
                    <div key={r.src} className="flex items-center gap-3 text-[11px]" data-testid={`scan-${r.src}`}>
                      <span className="min-w-0 flex-1 truncate font-semibold text-slate-700">{r.label}</span>
                      <span className="font-num text-slate-400">{r.opened} aperture</span>
                      <span className="font-num font-bold text-slate-900">{r.trials} prove</span>
                      <span className="font-num w-12 text-right text-emerald-700">{r.conversion_pct}%</span>
                    </div>
                  ))}
                  <p className="pt-1 text-[10px] text-slate-400">
                    {scans.trials_direct} prove sono arrivate da sole, senza biglietto.
                  </p>
                </div>
              </div>
            )}
            {(trials?.rows || []).map((r) => (
              <div key={r.id} className="flex flex-wrap items-center gap-3 rounded-md border border-slate-800 p-3" data-testid={`trial-${r.slug}`}>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold">
                    {r.name} <span className="font-normal text-slate-400">· {r.slug}</span>
                  </p>
                  <p className="text-[11px] text-slate-400">
                    {r.email || "senza email"} · {PLAN_NAME[r.plan] || r.plan}
                    {r.days_left != null && r.state === "attiva" && ` · ${r.days_left} giorni alla scadenza`}
                    {r.state === "scaduta" && r.days_to_purge != null && ` · dati eliminati fra ${r.days_to_purge} giorni`}
                  </p>
                  {r.progress && (
                    <div className="mt-2 flex flex-wrap items-center gap-2" data-testid={`trial-progress-${r.slug}`}>
                      <div className="flex gap-1">
                        {(r.progress.steps || []).map((s) => (
                          <span
                            key={s.id}
                            title={s.label}
                            className={`h-1.5 w-6 rounded-full ${s.done ? "bg-emerald-400" : "bg-slate-700"}`}
                          />
                        ))}
                      </div>
                      <span className="font-num text-[10px] text-slate-400">
                        {r.progress.done}/{r.progress.of}
                      </span>
                      <span className="text-[10px] text-slate-400">
                        {r.progress.reached} · da {r.ref_label}
                      </span>
                    </div>
                  )}
                </div>
                <span
                  className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.14em] ${
                    r.state === "attiva" ? "bg-emerald-100 text-emerald-800"
                      : r.state === "scaduta" ? "bg-amber-100 text-amber-800"
                        : r.state === "convertita" ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-400"
                  }`}
                  data-testid={`trial-state-${r.slug}`}
                >
                  {r.state}
                </span>
                {r.state !== "archiviata" && (
                  <Button
                    size="sm"
                    variant="outline"
                    data-testid={`trial-extend-${r.slug}`}
                    onClick={() => act(() => client.post(`/admin/tenants/${r.id}/trial/extend`, { days: 7 }), "Prova prorogata di 7 giorni")}
                  >
                    +7 giorni
                  </Button>
                )}
                {r.state !== "archiviata" && (
                  <RegalaMesi
                    tenant={r}
                    testid={`trial-gift-${r.slug}`}
                    onRegala={(mesi) =>
                      act(() => client.post(`/admin/tenants/${r.id}/gift`, { months: mesi }),
                          `${mesi} mesi Pro regalati a ${r.name}: email di avviso inviata`)}
                  />
                )}
                {r.state !== "archiviata" && (
                  <Button
                    size="sm"
                    data-testid={`trial-convert-${r.slug}`}
                    onClick={() => act(() => client.post(`/admin/tenants/${r.id}/plan`, { plan: "pro", months: 12, note: "convertita da prova" }), "Attività convertita a cliente Pro")}
                  >
                    Converti a cliente
                  </Button>
                )}
              </div>
            ))}
            {(trials?.rows || []).length === 0 && <p className="py-2 text-sm text-slate-400">Nessuna prova attivata.</p>}
          </div>
        </Card>

        <div className={tab === "log" ? "mb-4 grid gap-4" : "hidden"}>
          <BackupStato client={client} />
          <SaluteSistema client={client} />
        </div>

        <Card className={`space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "log" ? "" : "hidden"}`} data-testid="console-audit">          <div>
            <h2 className="font-head text-lg font-bold">Registro accessi e azioni</h2>
            <p className="text-xs text-slate-400">
              Ogni operazione della console è scritta qui e non può essere cancellata da nessuna pagina.
            </p>
          </div>
          <div
            className={`rounded-md border px-3 py-2 text-xs ${audit?.integrita?.ok === false
              ? "border-rose-500/40 bg-rose-500/10 text-rose-300"
              : "border-emerald-500/30 bg-emerald-500/10 text-emerald-300"}`}
            data-testid="audit-integrita"
          >
            {audit?.integrita?.ok === false
              ? `Attenzione: il registro risulta alterato alla riga ${audit.integrita.rotta_al_numero} (${String(audit.integrita.quando).slice(0, 16).replace("T", " ")}). Qualcuno è intervenuto direttamente sul database.`
              : `Registro intatto: ${audit?.integrita?.righe ?? 0} righe firmate e legate una all'altra.${audit?.integrita?.senza_firma ? ` Altre ${audit.integrita.senza_firma} righe sono precedenti alle firme.` : ""}`}
          </div>
          <div className="max-h-80 space-y-1 overflow-y-auto" data-testid="audit-rows">
            {(audit?.rows || []).map((r, i) => (
              <div key={r.id || `${r.at}-${i}`} className="flex flex-wrap items-baseline gap-x-2 border-b border-slate-800 py-2 text-xs">
                <span className="font-num text-slate-400">{String(r.at).slice(0, 16).replace("T", " ")}</span>
                <span className="font-semibold">{r.action}</span>
                {r.target && <span className="text-slate-400">· {r.target}</span>}
                {r.detail && <span className="text-slate-400">· {r.detail}</span>}
                <span className="ml-auto text-slate-400">{r.actor} · {r.ip}</span>
              </div>
            ))}
            {(audit?.rows || []).length === 0 && <p className="py-2 text-sm text-slate-400">Nessuna azione registrata.</p>}
          </div>
        </Card>

        <div className={tab === "prove" ? "mb-4" : "hidden"}>
          <ProveDalVivo client={client} />
        </div>

        <Card className={`space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "prove" ? "" : "hidden"}`} data-testid="console-quiz-funnel">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <h2 className="font-head text-lg font-bold">Test attività: dove si fermano</h2>
              <p className="text-xs text-slate-400">
                Contiamo solo chi risponde almeno alla prima domanda. Le nostre prove tecniche sono escluse.
              </p>
            </div>
            <div className="flex gap-1.5" data-testid="quiz-periodo">
              {[[30, "30 giorni"], [90, "90 giorni"], [3000, "Sempre"]].map(([g, l]) => (
                <button
                  key={g}
                  onClick={() => setQuizGiorni(g)}
                  data-testid={`quiz-periodo-${g}`}
                  className={`min-h-[36px] rounded-lg px-3 text-xs font-semibold transition-colors ${
                    quizGiorni === g ? "bg-amber-500 text-slate-950" : "bg-slate-800 text-slate-300 hover:bg-slate-700"
                  }`}
                >
                  {l}
                </button>
              ))}
            </div>
          </div>

          <p className="rounded-md bg-slate-900/60 px-3 py-2 text-xs text-slate-400" data-testid="quiz-peeked">
            {(funnel?.peeked ?? 0) === 0
              ? "Nessuno ha aperto il test senza rispondere."
              : `${funnel.peeked} ${funnel.peeked === 1 ? "persona ha" : "persone hanno"} aperto il test e chiuso subito, senza rispondere: curiosi, non abbandoni.`}
          </p>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            {[["Hanno risposto", funnel?.sessions ?? 0], ["Completati", funnel?.completed ?? 0],
              ["Conversione", `${funnel?.conversion_pct ?? 0}%`],
              ["Domanda critica", funnel?.worst_step?.label || "nessuna"]].map(([l, v2]) => (
              <div key={l} className="rounded-md border border-slate-800 p-3" data-testid={`quiz-kpi-${l.replace(/\s+/g, "-").toLowerCase()}`}>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">{l}</p>
                <p className="mt-2 text-base font-bold">{v2}</p>
              </div>
            ))}
          </div>

          <div className="space-y-2">
            {(funnel?.steps || []).map((s) => (
              <div key={s.step} data-testid={`quiz-step-${s.step}`}>
                <div className="flex items-center justify-between gap-2 text-xs">
                  <span className="font-semibold text-slate-200">{s.step}. {s.label}</span>
                  <span className="font-num text-slate-400">
                    {s.reached} arrivati · {s.reached_pct}%
                    {s.abandoned > 0 && <span className="ml-1.5 font-semibold text-rose-400">−{s.abandoned} persi</span>}
                  </span>
                </div>
                <div className="mt-1 h-2 overflow-hidden rounded-full bg-slate-800">
                  <div className="h-2 rounded-full bg-amber-500 transition-all" style={{ width: `${s.reached_pct}%` }} />
                </div>
              </div>
            ))}
            {(funnel?.sessions ?? 0) === 0 && (
              <p className="py-2 text-sm text-slate-400">
                Nessuna risposta nel periodo scelto{(funnel?.peeked ?? 0) > 0 ? `: ${funnel.peeked} hanno solo aperto il test.` : "."} Prova con «Sempre».
              </p>
            )}
          </div>
        </Card>

        <Card className={`space-y-3 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "prove" ? "" : "hidden"}`} data-testid="console-clic">
          <div>
            <h2 className="font-head text-lg font-bold">Link che ho mandato</h2>
            <p className="text-xs text-slate-400">
              Quante volte sono stati aperti i link delle mie email. Nessun pixel nascosto e nessun
              indirizzo salvato: solo il conteggio.
            </p>
          </div>
          {(clic?.campagne || []).length === 0 ? (
            <p className="py-1 text-sm text-slate-400">Nessun link ancora aperto.</p>
          ) : (
            <ul className="space-y-2">
              {clic.campagne.map((c) => (
                <li key={c.campagna} className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg bg-slate-900/60 px-3 py-2 text-sm">
                  <span className="font-semibold capitalize">{c.campagna.replace(/-/g, " ")}</span>
                  <span className="font-num text-slate-300">{c.inviati} inviati</span>
                  <span className="font-num font-bold text-emerald-400">{c.clic} aperti</span>
                  <span className="font-num text-slate-400">{c.percentuale}%</span>
                  {c.ultimo && (
                    <span className="ml-auto text-xs text-slate-500">
                      ultimo il {String(c.ultimo).slice(8, 10)}/{String(c.ultimo).slice(5, 7)}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          )}
        </Card>


        <Card className={`space-y-4 border-slate-800 bg-[#111827] p-5 text-slate-100 ${tab === "log" ? "" : "hidden"}`} data-testid="console-feedback">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <h2 className="font-head text-lg font-bold">Questionari di gradimento</h2>
              <p className="text-xs text-slate-400">Pareri raccolti dalla versione beta: cosa piace e cosa manca.</p>
            </div>
            {fb?.emails?.length > 0 && (
              <Button variant="outline" size="sm" data-testid="copy-feedback-emails-btn" onClick={() => navigator.clipboard?.writeText(fb.emails.join(", "))}>
                <Copy className="mr-1.5 h-3.5 w-3.5" /> Copia {fb.emails.length} email
              </Button>
            )}
          </div>

          <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
            {[["Questionari", fb?.count ?? 0], ["Voto medio", fb?.avg_rating ?? 0], ["Facilità media", fb?.avg_ease ?? 0], ["La userebbero", fb?.would_use ?? 0]].map(([l, v2]) => (
              <div key={l} className="rounded-md border border-slate-800 p-3" data-testid={`fb-kpi-${l.replace(/\s+/g, "-").toLowerCase()}`}>
                <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400">{l}</p>
                <p className="font-num mt-2 text-xl font-bold">{v2}</p>
              </div>
            ))}
          </div>

          {(fb?.per_area || []).length > 0 && (
            <div className="flex flex-wrap gap-2">
              {fb.per_area.map(([a, n]) => (
                <span key={a} className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-medium text-slate-700">
                  {a} · {n}
                </span>
              ))}
            </div>
          )}

          <div className="space-y-2">
            {(fb?.rows || []).length === 0 && <p className="py-2 text-sm text-slate-400">Nessun questionario ricevuto.</p>}
            {(fb?.rows || []).map((r) => (
              <div key={r.id} className="rounded-md border border-slate-800 p-3" data-testid={`feedback-${r.id}`}>
                <div className="flex flex-wrap items-center gap-2 text-xs text-slate-400">
                  <span className="font-num rounded bg-amber-100 px-1.5 font-bold text-amber-800">{r.rating}/5</span>
                  <span className="font-semibold text-slate-700">{r.business || r.tenant_name}</span>
                  <span>{r.role}</span>
                  {r.best_area && <span>· {r.best_area}</span>}
                  {r.would_use && <span>· la userebbe: {r.would_use}</span>}
                  <span className="ml-auto font-num">{new Date(r.at).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })}</span>
                </div>
                {r.missing && <p className="mt-2 whitespace-pre-wrap text-sm">{r.missing}</p>}
                {r.email && <p className="mt-1 text-[11px] font-medium text-slate-600">{r.email}</p>}
                <button
                  className="mt-2 text-[11px] font-semibold text-rose-600 hover:underline"
                  data-testid={`delete-feedback-${r.id}`}
                  onClick={() => act(() => client.delete(`/admin/feedback/${r.id}`), "Questionario rimosso")}
                >
                  Elimina
                </button>
              </div>
            ))}
          </div>
        </Card>

        <div className={`space-y-4 ${tab === "documenti" ? "" : "hidden"}`}>
          <ConsoleDocumenti client={client} tenants={data.tenants} />
          <FirmeLegali client={client} />
        </div>
      </div>
    </div>
  );
}
